import React from "react";
import { Tabs } from "@shared/ui/tabs";
import { DetailTab } from "./tabs/detailTab/detailTab";
import { PlanAndDepositTab } from "./tabs/planAndDepositTab/planAndDepositTab";

interface OverviewLandingProps {
  consumer?: any;
  consumerId: string;
  consumerNo: string;
  remoteUtilityId: number;
}

export const OverviewLanding: React.FC<OverviewLandingProps> = (props) => {
  const tabComponents = {
    details: {
      label: "Details",
      component: <DetailTab {...props} />,
    },
    planAndDeposit: {
      label: "Plan & Deposit",
      component: <PlanAndDepositTab {...props} />,
    },
  };

  const urlMapping = {
    details: "details",
    planAndDeposit: "plan-and-deposit",
  };

  return (
    <div className="w-full space-y-4">
      <Tabs
        defaultValue="details"
        className="w-full"
        tabsListClassName="grid grid-cols-2 w-full max-w-sm"
        urlMapping={urlMapping}
        tabComponents={tabComponents}
        level={1}
      />
    </div>
  );
};

export default OverviewLanding;
